import React from "react";
import { noUserInProd } from "../../utils/helpers/UserHelper";
import { useUserContext } from "../context/user/UserContext";

function ToolsFooter(): JSX.Element {
  const { getUser } = useUserContext();
  const currentYear = new Date().getFullYear();

  if (noUserInProd(getUser())) return null;

  return (
    <footer className="absolute bottom-0 w-full bg-NexstarBlue-dark p-3 text-white text-sm text-center z-[1298]">
      <div className="flex gap-6 justify-center">
        <p>
          © {currentYear} Nexstar Network. All rights reserved. Unauthorized
          distribution is prohibited.
        </p>
        <a
          href={"/downloads/Nexstar_Privacy_Policy.pdf"}
          className="text-white underline"
          download
        >
          Privacy Policy
        </a>
      </div>
    </footer>
  );
}

export default ToolsFooter;
